import { Typography } from '@mui/material';
import { TagChip } from 'components/ui';
import colors from 'lib/colors';
import { TableContext } from 'pages/PatientsPage';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export const CareTeamFilterChip = () => {
  const { t } = useTranslation();
  const { filters, setFilters } = useContext(TableContext);

  const selectedCareTeams = filters?.careTeamIds;

  function deleteFilter(careTeam) {
    const newCareTeamFilter = filters.careTeamIds.filter(
      (item) => item.id !== careTeam.id
    );
    setFilters({
      ...filters,
      careTeamIds: newCareTeamFilter,
    });
  }

  return selectedCareTeams?.map((careTeam) => (
    <TagChip
      key={careTeam.id}
      tag={
        <>
          <Typography
            component="span"
            color={colors.black}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {`${t('Care team')}: `}
          </Typography>
          <Typography
            component="span"
            color={colors.blue100}
            fontSize={'0.875rem'}
            fontWeight={'500'}
          >
            {careTeam.name}
          </Typography>
        </>
      }
      handleDelete={() => deleteFilter(careTeam)}
      isCanDelete
      iconColor={colors.blue100}
    />
  ));
};
